<template>
    <div class="f-nav-image" :ref="ref">
        <div class="outer-wrap"
          :style="outerWrapStyle">
            <div class="inner-wrap">
                <div class="list-wrap"
                  :style="listWrapStyle">
                    <div class="list" v-for="(item, index) in list"
                      :class="{ 'active': item.active }"
                      :key="item.id"
                      :index="index"
                      v-on:click="onListClickHandle">
                        <img :src="item.imageUrl.replace(/^http:|https:/, location.protocol)" :alt="item.text">
                    </div>
                    <div class="slider"
                      :style="sliderStyle"></div>
                </div>
            </div>
        </div>
        <div class="category-bar"
          v-if="categoryBar"
          :style="categoryBarStyle"
          v-on:click="onBarClickHandle">
            <img :src="categoryBar.imageUrl.replace(/^http:|https:/, location.protocol)">
            <div class="shadow"></div>
        </div>
    </div>
</template>

<script>
    import utils from '../utils'

    export default {
        name: 'f-nav-image',
        data () {
            var activeIndex = 0
            this.listItem.forEach((element, index) => {
                if (element.active) {
                    activeIndex = index
                }
            })

            if (this.listItem.length) {
                this.listItem[activeIndex]['active'] = true
            }

            return {
                location: window.location,
                list: this.listItem,
                activeIndex: activeIndex,
                sliderPosition: 0,
                $nav: null,
                ref: 'f-nav-image' + (+new Date())
            }
        },
        props: {
            listItem: {
                type: Array,
                required: true
            },
            navConfig: {
                type: Object,
                default: {
                    backGroundColor: '#2a323d',
                    selectedBackGroundColor: ['#ff6646', '#fe1d61']
                }
            },
            categoryBar: {
                type: Object
            }
        },
        computed: {
            outerWrapStyle () {
                return {
                    background: this.navConfig.backGroundColor
                }
            },
            categoryBarStyle () {
                var rgba = utils.hex2rgba(this.navConfig.backGroundColor, 0.95)
                return {
                    background: 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')'
                }
            },
            sliderStyle () {
                var start = this.navConfig.selectedBackGroundColor[0]
                var end = this.navConfig.selectedBackGroundColor[1]
                return {
                    background: 'linear-gradient(to bottom, ' + start + ' 0%, ' + end + ' 100%)',
                    transform: 'translateX(' + this.sliderPosition + 'px)'
                }
            },
            listWrapStyle () {
                return {
                    paddingRight: (this.categoryBar ? 45 : 0) + 'px',
                    width: 60 * this.listItem.length + 'px'
                }
            }
        },
        watch: {
            activeIndex () {
                this.$nextTick(function () {
                    this.locationActive()
                })
            }
        },
        mounted () {
            this.$nav = this.$refs[this.ref]
            this.locationActive()
        },
        beforeDestroy () {
            this.$nav = null
        },
        methods: {
            onListClickHandle (e) {
                var target = utils.closest(e.target, 'list')
                var index = target.getAttribute('index')

                this.list[this.activeIndex]['active'] = false
                this.list[index]['active'] = true
                this.activeIndex = index

                this.$emit('nav-item-click', e, JSON.parse(JSON.stringify(this.list[index])))
            },
            onBarClickHandle (e) {
                this.$emit('category-bar-click', e, JSON.parse(JSON.stringify(this.categoryBar)))
            },
            navScrollCenter () {
                if (!this.listItem.length) return

                var clientWidth = document.body.clientWidth
                var $navWrap = this.$nav.querySelector('.inner-wrap')
                var $nav = this.$nav.querySelector('.inner-wrap .list-wrap')
                var $navIcon = this.$nav.querySelector('.category-bar')
                var $active = $nav.querySelector('.active')
                var maxLeft = $nav.offsetWidth - clientWidth + ($navIcon ? $navIcon.offsetWidth : 0)

                if (!$active) return

                var midPoint = (clientWidth - $active.offsetWidth) / 2
                var offsetLeft = midPoint - $active.offsetLeft

                offsetLeft = offsetLeft > 0 ? 0 : offsetLeft
                offsetLeft = offsetLeft < (-maxLeft) ? (-maxLeft) : offsetLeft

                var from = $navWrap.scrollLeft
                var to = Math.abs(offsetLeft)
                if (from !== to) {
                    utils.animation(from, to, 300, 'Linear', (scrollLeft, isEnding) => {
                        $navWrap.scrollLeft = scrollLeft
                    })
                }
            },
            locationActive () {
                if (!this.listItem.length) return

                var self = this
                var $active = this.$nav.querySelector('.list-wrap .active')
                var offsetLeft = $active.offsetLeft

                this.sliderPosition = offsetLeft

                setTimeout(function () {
                    self.navScrollCenter()
                }, 300)
            }
        }
    }
</script>

<style lang="stylus">
    .f-nav-image
        height: 50px
        position: relative

        .outer-wrap
            height: 100%
            overflow: hidden
            background: #2a323d;

            .inner-wrap
                height: 140%
                overflow: hidden
                overflow-x: scroll
                -webkit-overflow-scrolling: touch

                .list-wrap
                    -webkit-overflow-scrolling: touch;
                    display: -webkit-box
                    display: -webkit-flex
                    display: flex
                    -webkit-box-pack: start
                    -webkit-justify-content: start
                    justify-content: flex-start
                    -webkit-box-align: stretch
                    -webkit-align-items: stretch
                    align-items: stretch
                    position: relative
                    height: 50px
                
                    .list
                        display: -webkit-box
                        display: -webkit-flex
                        display: flex
                        -webkit-box-pack: center
                        -webkit-justify-content: center
                        justify-content: center
                        -webkit-box-align: center
                        -webkit-align-items: center
                        align-items: center
                        width: 60px
                        height: 50px
                        position: relative
                        z-index: 1
                        
                        img
                            display: block
                    .slider
                        width: 60px
                        height: 50px
                        left: 0
                        top: 0
                        position: absolute
                        background: #ff6646
                        background: -moz-linear-gradient(top, #ff6646 0%, #fe1d61 100%)
                        background: -webkit-linear-gradient(top, #ff6646 0%, #fe1d61 100%)
                        background: linear-gradient(to bottom, #ff6646 0%, #fe1d61 100%)
                        -webkit-transition: all ease-in-out 0.3s;
                        transition: all ease-in-out 0.3s;

        .category-bar
            position: absolute
            width: 45px
            height: 50px
            display: -webkit-box
            display: -webkit-flex
            display: flex
            -webkit-box-pack: center
            -webkit-justify-content: center
            justify-content: center
            -webkit-box-align: center
            -webkit-align-items: center
            align-items: center
            right: 0
            top: 0
            background: rgba(42, 50, 61, .95)
            z-index: 10

            img
                display: block
            .shadow
                position: absolute
                width: 3px
                height: 50px
                background: url(//cdn.upin.com/mfanhuan/common/FUI/1.2.1/image/menu-category-shadow.png) left top no-repeat
                background-size: cover
                left: -3px
                top: 0

</style>


// WEBPACK FOOTER //
// nav-image.vue?6e5afa3e